import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { FIELD_ERROR_CLASSES, FIELD_LABEL_CLASSES, SELECT_STYLING_PROPS } from "@/constants/forms"
import { CompanyCertificationType } from "@/graphql/codegen/graphql"
import { getCertificationLabel } from "@/screens/Companies/edit/components/certification/utils"

const CertificationTypesOptions = Object.values(CompanyCertificationType).map((value) => ({
  value: value.toString(),
  label: getCertificationLabel(value),
}))

interface Props {
  name: string
  disabled?: boolean
  label?: string
}

const CertificationTypeSelect: FC<Props> = ({ disabled, name, label = "Certification Type" }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth data-testid={`${name}-select`}>
          <InputLabel id='certificationType' className={FIELD_LABEL_CLASSES}>
            {label}
            <span className='text-red-600'>*</span>
          </InputLabel>
          <Select
            {...field}
            {...SELECT_STYLING_PROPS}
            labelId='certificationType'
            disabled={disabled}
            error={!!error}
            renderValue={(value) => {
              if (!value) {
                return <span className='text-gray-500'>Select One</span>
              }
              return CertificationTypesOptions.find((e) => e.value === value)?.label
            }}
          >
            {CertificationTypesOptions.map(({ value, label }) => (
              <MenuItem key={field.name + value} value={value} className='pl-8'>
                {label}
              </MenuItem>
            ))}
          </Select>
          {error?.message && <p className={FIELD_ERROR_CLASSES}>{error.message}</p>}
        </FormControl>
      )}
    />
  )
}
export default CertificationTypeSelect
